import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getName = (state: RootState) => state.pages.editor.scene.name;

const getSceneName = createSelector([getName], (name) => name);

export default getSceneName;
